import React from 'react';
import { ImageCol } from '@/components/ImageCol';
import {
    ImageContentCol,
    IMAGE_CONTENT_COL_SPACING
} from '@/components/ImageContentCol';
import RenderDotPoints from '@/components/RenderDotPoints';
import RenderParagraphs from '@/components/RenderParagraphs';
import { useTranslationHook } from '@/hooks/useTranslationHook';

const LightIndustrialSection = () => {
    const { translate } = useTranslationHook();

    return (
        <div className='mt-4' id='top'>
            <ImageContentCol title={translate('industrialSectionTitle')}
                             spacing={IMAGE_CONTENT_COL_SPACING.BOTTOM}
                             leftContent={
                                 <>
                                     <RenderParagraphs translateLabel='industrialParagraphs'/>
                                     <h5>{translate('industrialSubTitle')}</h5>
                                     <RenderDotPoints translateLabel='industrialItemList'/>
                                 </>
                             }
                             rightContent={
                                 <div className='job-seeker-image'>
                                     <ImageCol src={'core-staff-industrial.png'}
                                               alt={'standing-workers'}/>
                                 </div>
                             }
            />

        </div>
    );
};

export default LightIndustrialSection;